import { render, staticRenderFns } from "./data-look.vue?vue&type=template&id=ca7619ea&scoped=true&"
import script from "./data-look.vue?vue&type=script&lang=js&"
export * from "./data-look.vue?vue&type=script&lang=js&"
import style0 from "./data-look.vue?vue&type=style&index=0&id=ca7619ea&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca7619ea",
  null
  
)

export default component.exports